import type { TableActionTarget } from './types';
import type { ReactNode } from 'react';

import { IconButton } from '@/components';

type TableActionProps = {
  target: TableActionTarget;
  label: string;
  icon: ReactNode;
};

export const TableAction = (props: TableActionProps) => {
  const { target, label, icon } = props;

  if ('url' in target) {
    return (
      <IconButton
        label={label}
        asChild
      >
        <a href={target.url}>{icon}</a>
      </IconButton>
    );
  }

  return (
    <IconButton
      label={label}
      onClick={target.onClick}
    >
      {icon}
    </IconButton>
  );
};
